import { __assign, __extends } from "tslib";
import React from 'react';
import { GALLERY_CONSTS, processLayouts, addPresetStyles, isSEOMode, utils, } from 'pro-gallery-lib';
import { getInnerInfoStyle } from '../../item/itemViewStyleProvider';
//import './leanGallery.scss';
var LeanGallery = /** @class */ (function (_super) {
    __extends(LeanGallery, _super);
    function LeanGallery() {
        var _this = _super.call(this) || this;
        _this.measureIfNeeded = _this.measureIfNeeded.bind(_this);
        _this.eventsListener = _this.eventsListener.bind(_this);
        _this.state = {
            itemStyle: {},
            numberOfColumns: 0,
        };
        return _this;
    }
    // #region Lifecycle functions
    LeanGallery.prototype.componentDidMount = function () {
        this.eventsListener(GALLERY_CONSTS.events.APP_LOADED, {});
        this.measureIfNeeded();
        this.setState({
            numberOfColumns: this.calcNumberOfColumns(this.props),
        });
    };
    LeanGallery.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (this.props.container.galleryWidth !== nextProps.container.galleryWidth) {
            this.measureIfNeeded();
            this.setState({
                numberOfColumns: this.calcNumberOfColumns(nextProps),
            });
        }
    };
    // #endregion
    // #region Gallery
    LeanGallery.prototype.createGalleryStyle = function () {
        var _a = this.props.styles, gridStyle = _a.gridStyle, fixedColumns = _a.fixedColumns, imageMargin = _a.imageMargin, cubeImages = _a.cubeImages;
        var itemSize = this.calcItemContainerSize();
        var numberOfColumns = gridStyle === GALLERY_CONSTS.gridStyle.SET_ITEMS_PER_ROW
            ? fixedColumns
            : this.state.numberOfColumns;
        var gridTemplateColumns = numberOfColumns > 0
            ? "repeat(" + numberOfColumns + ", 1fr)"
            : "repeat(auto-fit, minmax(" + itemSize.width + "px, 1fr))";
        return __assign({ gridTemplateColumns: gridTemplateColumns, gridGap: imageMargin / 2 + "px" }, (cubeImages === false
            ? {
                gridAutoRows: 'minmax(max-content, 1px)',
                gridGap: 0,
                columnGap: imageMargin / 2 + "px",
            }
            : {}));
    };
    LeanGallery.prototype.calcNumberOfColumns = function (props) {
        var galleryWidth = props.container.galleryWidth;
        if (!galleryWidth) {
            return 0;
        }
        var itemSize = this.calcItemContainerSize(undefined, props);
        var numOfCols = 1;
        if (props.styles.fixedColumns > 0) {
            numOfCols = props.styles.fixedColumns;
        }
        else {
            // find the number of columns that makes each column width the closet to the itemSize
            var numOfColsFloat_1 = galleryWidth / itemSize.width;
            var roundFuncs = [Math.floor, Math.ceil];
            var diffs = roundFuncs
                .map(function (func) { return func(numOfColsFloat_1); }) //round to top, round to bottom
                .map(function (n) { return Math.round(galleryWidth / n); }) //width of each col
                .map(function (w) { return Math.abs(itemSize.width - w); }); //diff from itemSize
            var roundFunc = roundFuncs[diffs.indexOf(Math.min.apply(Math, diffs))]; //choose the round function that has the lowest diff from the itemSize
            numOfCols = roundFunc(numOfColsFloat_1) || 1;
        }
        return numOfCols;
    };
    // #endregion
    // #region Item container
    LeanGallery.prototype.calcItemContainerSize = function (item, props) {
        var _a = props || this.props, styles = _a.styles, container = _a.container;
        var targetItemSize = styles.targetItemSize, cubeImages = styles.cubeImages, titlePlacement = styles.titlePlacement, textBoxHeight = styles.textBoxHeight, cubeRatio = styles.cubeRatio, imageMargin = styles.imageMargin;
        var itemWidth = container.width > 0
            ? Math.min(targetItemSize, container.width)
            : targetItemSize;
        var itemHeight = itemWidth / cubeRatio;
        if (item && cubeImages === false) {
            var ratio = get(item, 'width') / get(item, 'height');
            itemHeight = Math.round((itemWidth - imageMargin / 2) / ratio);
        }
        if (GALLERY_CONSTS.hasVerticalPlacement(titlePlacement)) {
            itemHeight += textBoxHeight;
        }
        return {
            width: itemWidth,
            height: itemHeight,
        };
    };
    LeanGallery.prototype.createItemContainerStyle = function (clickable, item) {
        var _a = this.state.itemStyle.height, height = _a === void 0 ? null : _a;
        var _b = this.props.styles, imageMargin = _b.imageMargin, cubeImages = _b.cubeImages;
        var itemSize = this.calcItemContainerSize(item);
        var noCropStyle = cubeImages === false
            ? {
                gridRowEnd: "span " + itemSize.height,
                marginBottom: imageMargin / 2 + "px",
                height: 'fit-content',
            }
            : {};
        return __assign(__assign(__assign(__assign({}, this.createItemContainerBorder()), (height
            ? { height: 'auto' }
            : { height: 'auto', textAlign: 'center' })), { cursor: clickable ? 'pointer' : 'default' }), noCropStyle);
    };
    LeanGallery.prototype.createItemContainerBorder = function () {
        // Set border of the entire Item - including the info text
        var styles = this.props.styles;
        if (styles.imageInfoType === GALLERY_CONSTS.infoType.ATTACHED_BACKGROUND) {
            return {
                borderStyle: 'solid',
                borderWidth: styles.itemBorderWidth,
                borderColor: utils.formatColor(styles.itemBorderColor),
                borderRadius: styles.itemBorderRadius,
            };
        }
    };
    // #endregion
    // #region Image wrapper
    LeanGallery.prototype.createImageWrapperStyle = function (item) {
        var _a = this.props.styles, cubeType = _a.cubeType, cubeImages = _a.cubeImages;
        if (this.state.itemStyle.width &&
            cubeType !== GALLERY_CONSTS.resizeMethods.FIT) {
            var itemSize = this.calcItemContainerSize(item);
            return cubeImages === false
                ? __assign({}, itemSize) : __assign({}, this.state.itemStyle);
        }
        else if (!(this.state.itemStyle.width > 0)) {
            return {
                width: '100%',
                height: 'auto',
            };
        }
        var _b = this.state.itemStyle, width = _b.width, height = _b.height;
        var imageWidth = get(item, 'width');
        var imageHeight = get(item, 'height');
        var imageRatio = imageWidth / imageHeight;
        var containerRatio = width / height;
        if (imageRatio > containerRatio) {
            //image is wider than container
            var _height = width / imageRatio;
            return {
                width: width,
                height: _height,
                marginTop: (height - _height) / 2,
            };
        }
        else {
            var _width = height * imageRatio;
            return {
                height: height,
                width: _width,
                marginLeft: (width - _width) / 2,
            };
        }
    };
    // #endregion
    // #region Image
    LeanGallery.prototype.resizeUrl = function (_a) {
        var item = _a.item;
        var _b = this.props, styles = _b.styles, resizeMediaUrl = _b.resizeMediaUrl;
        var cubeType = styles.cubeType, imageQuality = styles.imageQuality, cubeRatio = styles.cubeRatio, cubeImages = styles.cubeImages;
        var itemStyle = this.state.itemStyle;
        var url = item.url, mediaUrl = item.mediaUrl, src = item.src;
        var itemUrl = url || mediaUrl || src;
        var itemSize = this.calcItemContainerSize(item);
        var width = (cubeImages === true && itemStyle.width) || itemSize.width;
        var height = (cubeImages === true && itemStyle.height) || itemSize.height / cubeRatio;
        var focalPoint = false;
        var isPreload = !(itemStyle.width > 0);
        var options = isPreload
            ? { quality: 30, blur: 30 }
            : { quality: imageQuality };
        if (typeof resizeMediaUrl === 'function') {
            try {
                return (resizeMediaUrl({
                    maxWidth: get(item, 'width'),
                    maxHeight: get(item, 'height'),
                }, itemUrl, cubeType, width, height, options, false, focalPoint) || '');
            }
            catch (e) {
                return String(itemUrl);
            }
        }
        else {
            return String(itemUrl);
        }
    };
    LeanGallery.prototype.createImageStyle = function (imageWrapperStyle) {
        var _a = imageWrapperStyle.width, width = _a === void 0 ? '100%' : _a, _b = imageWrapperStyle.height, height = _b === void 0 ? 'auto' : _b;
        var blockDownloadStyles = utils.isiOS() && !this.props.styles.allowContextMenu
            ? { '-webkit-user-select': 'none', '-webkit-touch-callout': 'none' }
            : {};
        return __assign(__assign({ width: width,
            height: height }, blockDownloadStyles), this.createImageBorder());
    };
    LeanGallery.prototype.createImageBorder = function () {
        var styles = this.props.styles;
        if (styles.imageInfoType !== GALLERY_CONSTS.infoType.ATTACHED_BACKGROUND) {
            return {
                boxSizing: 'border-box',
                borderStyle: 'solid',
                borderWidth: styles.itemBorderWidth,
                borderColor: utils.formatColor(styles.itemBorderColor),
                borderRadius: styles.itemBorderRadius,
            };
        }
    };
    // #endregion
    // #region Helper functions
    LeanGallery.prototype.createLinkParams = function (item) {
        var _a = this.props, noFollowForSEO = _a.noFollowForSEO, styles = _a.styles;
        var itemClick = styles.itemClick;
        var directLink = item.directLink;
        var _b = directLink || {}, url = _b.url, target = _b.target;
        var isSEO = isSEOMode();
        var shouldUseNofollow = isSEO && noFollowForSEO;
        var seoLinkParams = shouldUseNofollow ? { rel: 'nofollow' } : {};
        var shouldUseDirectLink = !!(url &&
            target &&
            itemClick === GALLERY_CONSTS.itemClick.LINK);
        var linkParams = shouldUseDirectLink
            ? __assign({ href: url, target: target }, seoLinkParams) : false;
        return linkParams;
    };
    LeanGallery.prototype.measureIfNeeded = function (node) {
        var styles = this.props.styles;
        if (!this.node && node) {
            this.node = node;
        }
        if (this.node && this.node.clientWidth !== this.clientWidth) {
            this.clientWidth = this.node.clientWidth;
            this.setState({
                itemStyle: {
                    width: this.clientWidth,
                    height: Math.round(this.clientWidth / styles.cubeRatio),
                },
            });
        }
    };
    LeanGallery.prototype.fixStylesIfNeeded = function (styles) {
        return __assign(__assign({}, styles), { externalInfoHeight: styles.textBoxHeight });
    };
    LeanGallery.prototype.isMetadataLinkExists = function (item) {
        var metadata = item.metadata || item.metaData;
        return metadata && metadata.link ? true : false;
    };
    LeanGallery.prototype.eventsListener = function (eventName, eventData) {
        if (typeof this.props.eventsListener === 'function') {
            this.props.eventsListener(eventName, eventData);
        }
    };
    // #endregion
    LeanGallery.prototype.render = function () {
        var _this = this;
        var _a = this, eventsListener = _a.eventsListener, props = _a.props;
        var customInfoRenderer = props.customInfoRenderer, items = props.items;
        var styles = this.fixStylesIfNeeded(props.styles);
        var itemClick = styles.itemClick;
        return (React.createElement("div", { "data-hook": "lean-gallery", className: [
                'pro-gallery',
                'inline-styles',
                'lean-gallery-gallery',
            ].join(' '), style: this.createGalleryStyle() }, items.map(function (item, itemIdx) {
            var linkParams = _this.createLinkParams(item);
            var clickable = (linkParams && itemClick === GALLERY_CONSTS.itemClick.LINK) ||
                [
                    GALLERY_CONSTS.itemClick.EXPAND,
                    GALLERY_CONSTS.itemClick.FULLSCREEN,
                ].includes(itemClick) ||
                _this.isMetadataLinkExists(item);
            var itemData = __assign(__assign({}, item), { id: item.itemId, idx: itemIdx });
            var metadata = item.metaData || item.metadata;
            var itemProps = __assign(__assign(__assign({}, itemData), metadata), { style: _this.state.itemStyle, styleParams: styles });
            var imageWrapperStyle = _this.createImageWrapperStyle(item);
            var infoHeight = styles.textBoxHeight;
            var texts = function (placement) {
                return typeof customInfoRenderer === 'function' &&
                    styles.titlePlacement === placement && (React.createElement("div", { className: "gallery-item-common-info gallery-item-" + (placement === GALLERY_CONSTS.placements.SHOW_ABOVE
                        ? "top"
                        : "bottom") + "-info", style: getInnerInfoStyle(placement, styles, infoHeight) }, customInfoRenderer(itemProps, placement)));
            };
            return (React.createElement("a", __assign({ className: ['gallery-item-container', 'lean-gallery-cell'].join(' '), style: _this.createItemContainerStyle(clickable, item), ref: function (node) {
                    _this.measureIfNeeded(node);
                    eventsListener(GALLERY_CONSTS.events.ITEM_CREATED, itemData);
                }, key: 'item-container-' + itemIdx }, linkParams),
                texts(GALLERY_CONSTS.placements.SHOW_ABOVE),
                React.createElement("div", { style: imageWrapperStyle, className: [
                        'gallery-item-hover',
                        'lean-gallery-image-wrapper',
                    ].join(' '), onClick: function () {
                        return eventsListener(GALLERY_CONSTS.events.ITEM_ACTION_TRIGGERED, itemData);
                    } },
                    React.createElement("img", { src: _this.resizeUrl({ item: item }), loading: "lazy", className: [
                            'gallery-item-content',
                            'lean-gallery-image',
                        ].join(' '), alt: get(item, 'title'), style: _this.createImageStyle(imageWrapperStyle), onLoad: function () {
                            return eventsListener(GALLERY_CONSTS.events.ITEM_LOADED, itemData);
                        } })),
                texts(GALLERY_CONSTS.placements.SHOW_BELOW)));
        })));
    };
    return LeanGallery;
}(React.Component));
export default LeanGallery;
var get = function (item, attr) {
    if (typeof item[attr] !== 'undefined') {
        return item[attr];
    }
    var metadata = item.metadata || item.metaData;
    if (typeof metadata !== 'undefined') {
        if (typeof metadata[attr] !== 'undefined') {
            return metadata[attr];
        }
    }
};
export var formatLeanGalleryStyles = function (styles) {
    var customExternalInfoRendererExists = true;
    return processLayouts(addPresetStyles(styles), customExternalInfoRendererExists); // TODO make sure the processLayouts is up to date. delete addLayoutStyles from layoutsHelper when done with it...
};
//# sourceMappingURL=leanGallery.js.map